import { render, staticRenderFns } from "./tyokertymalaskuri-modal-content.vue?vue&type=template&id=86e65028&"
import script from "./tyokertymalaskuri-modal-content.vue?vue&type=script&lang=ts&"
export * from "./tyokertymalaskuri-modal-content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports